import React from 'react';
import { Row, Col, Space } from 'antd';


function SearchExamples(props) {
    const example1 = require('../examples/example_01.json');
    return (
        <Row>
            <Col xs={1} xl={4}>

            </Col>
            <Col xs={22} xl={16}>
                <h1>Search Basics</h1>

                <p>In this section, we will describe how to use the compass api to search for documents of interest.</p>

                <p>The compass API uses elastic search and through this API we allow you to perform most of the supported search types</p>

                <p>For a basic introduction see</p>

<p><a href="https://www.elastic.co/guide/en/elasticsearch/reference/current/search-your-data.html">https://www.elastic.co/guide/en/elasticsearch/reference/current/search-your-data.html</a></p>

<p>And for details of the full Elastic Query DSL (Domain Specific Language) based on JSON </p>

<p>https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl.html</p>

<p>Please note that some query types are not supported (for instance script queries)</p>

<p>Before you can make a search query make sure you have an access token. See the access section of the guide to get one of these.</p>

<p>Once you have your IDToken you can perform a search to the /search/resourcespublic endpoint.</p>

<p>For example</p>

<pre><code>curl -X POST "https://api.sabinet-arq.com/search/resourcespublic" -H "Content-Type: application/json" -d '&#123;"query":&#123;"bool":&#123;"must":[&#123;"match":&#123;"title":"test"&#125;&#125;],"must_not":[],"should":[]&#125;&#125;,"from":0,"size":10,"sort":[],"aggs":&#123;&#125;,"_source":&#123;"includes":["*"],"excludes":[]&#125;&#125;' -H "Authorization: ID TOKEN FROM LAST REQUEST" </code></pre>

<p>This will match all documents with the title test and return a list of the 10 most relevant results.</p>

<p>To see a list of common search fields check the Search Fields section of this guide.</p>

<p>In addition to the Elastic search requirements some of the elements of this request are mandatory in our search api </p>

<p>"from":.....,</p>
<p>"size":......,</p>
<p>"_source":&#123;"includes":["*"],"excludes":[]&#125;</p>

<p>If the token is active and verified the API will respond with a json object containing the results for example</p>
<pre><code>
&#123;
  "took":5,
  "timed_out":false,
  "_shards":&#123;
    "total":1,
    "successful":1,
    "skipped":0,
    "failed":0
  &#125;,
  "hits":&#123;
    "total":&#123;
      "value":10000,
      "relation":"gte"
    &#125;,
    "max_score":9.794312,
    "hits":[
      &#123;
        "_index":"resourcespublic",
        "_type":"_doc",
        "_id":"2510968",
        "_score":9.794312,
        "_source":&#123;
          "date":"2010-04-01",
          "journal_code":"sh_esor",
          "product_types":[
            "All Content",
            "Sabinet African Journals - All Journals"
          ],
          "ref":"2510968",
          "contributor_details":[
            &#123;
              "date":"",
              "ref":"2510969",
              "title":"Linzi Smith"
            &#125;
          ],
          "original_publication_week_start":"2020 01 06",
          "article_publication_type":[
            "research-article"
          ],
          "title":"To test or not to test ",
          "publisher_title":"Novus Print (Pty) Ltd t/a 3S Media",
          "external_location":"https://journals.co.za/doi/abs/10.10520/EJC102667"
        &#125;
      &#125;
    ]
  &#125;
&#125;
</code></pre>

<p>You can then use these directly or many of the other endpoints in the Compass API are based on the documentID also know as ref. You can take this from the ref field in the returned results and then use that documentID in further queries.</p>

<p>For instance to get a time-limited download path </p>
<p>/documents/documentID/path</p>


            </Col>
            <Col xs={1} xl={4}>

            </Col>
        </Row>
    )
}
export default SearchExamples;